import { FC } from "react";
import { Guideline as GuidelineSteps } from "../Guideline";
import { useGetMeQuery } from "store/api/auth";
import { useTeamQuery } from "store/api/member";
import { useGetSurveysQuery } from "store/api/survey";
import { getGuidelineSteps } from "utils/guideline";

const Guideline: FC = () => {
    const { data: meData, isLoading: isMeLoading } = useGetMeQuery();
    const { data: teamData, isLoading: isTeamLoading } = useTeamQuery();
    const { data: surveysData, isLoading: isSurveysLoading } =
        useGetSurveysQuery();
    const isLoading = isMeLoading || isTeamLoading || isSurveysLoading;
    const steps = getGuidelineSteps(meData, teamData, surveysData);

    return <GuidelineSteps isLoading={isLoading} steps={steps} />;
};

export default Guideline;
